<script>
import Modal from '../../../components/Modal.vue'

export default {
    components: {
        Modal
    },

    props: {
        jobApplication: {
            type: Object,
            required: true
        }
    },

    methods: {
        toggleModal() {
            this.$refs.modal.toggle()
        },
    }
}
</script>

<template>
   <modal ref="modal" heading="Background Verification Permission">
        <div class="mb-4">
            <h5>The candidate has not completed their iFacts form. Please ask the candidate to complete the form, or upload it manually.</h5>
        </div>

        <div class="grid-x grid-padding-x align-right">
            <div class="cell shrink">
                <button class="button warning" type="button" @click="toggleModal">Close</button>
            </div>
        </div>
    </modal>
</template>